import { useEffect, useState } from 'react';
import { fetchAPI } from '../../../utils/utils';
import { MODELS_EVENT_ID } from '../../interface/proves/modelFolders';

export default function useImportModelPaths({ enabled, userId, socket }) {
    const [result, setResult] = useState(null);

    useEffect(() => {
        setResult(null);
        if (!enabled || !userId) return;

        let cancelled = false;
        let requestId = 0;
        let timeout;
        const refresh = () => {
            const id = ++requestId;
            clearTimeout(timeout);
            const finish = paths => {
                if (cancelled || id !== requestId) return;
                clearTimeout(timeout);
                setResult({ userId, paths });
            };
            // A stalled request must not leave every model loading indefinitely.
            timeout = setTimeout(() => finish(false), 10000);
            fetchAPI(`/model-folders?userId=${encodeURIComponent(userId)}`, data => {
                const valid = data?.success && data.paths && typeof data.paths === 'object' && !Array.isArray(data.paths);
                finish(valid ? data.paths : false);
            }, false, () => finish(false));
        };
        const onChanged = event => {
            if (String(event) === String(MODELS_EVENT_ID)) refresh();
        };

        refresh();
        socket.on('.model_folders_updated', onChanged);
        socket.on('connect', refresh);
        return () => {
            cancelled = true;
            clearTimeout(timeout);
            socket.off('.model_folders_updated', onChanged);
            socket.off('connect', refresh);
        };
    }, [enabled, userId, socket]);

    if (!enabled || !userId) return false;
    return result?.userId === userId ? result.paths : null;
}
